import { ShareProjectData } from 'src/modules/sharing-projects/types/ShareProjectState';
import { RootState } from 'src/types/RootState';

export function getShareProjectData(state: RootState): ShareProjectData | null {
  return state.shareProject.data;
}
